module.exports = __webpack_public_path__ + "img/2.e5a27f2c.png";